export default __webpack_public_path__ + "static/media/chemex.53466b8b.png";